import { Box, Checkbox, ListItemText, MenuItem } from "@mui/material";
import FormInput from "../Common/FormInputs/MuiTextField";
import { inAppNotificationDialogMenuProps } from "../../utils/selectMenuProps";
import {
  PLATFORM_OPTIONS,
  compactInputSx,
} from "../../constants/inAppNotificationConstant";
import { normalizePlatformValues } from "../../utils/inAppNotificationUtils";

const labelFor = (value) =>
  PLATFORM_OPTIONS.find((opt) => opt.value === value)?.label ?? value;

const PlatformSelector = ({
  value = [],
  onChange,
  error,
  compact = true,
  readOnly = false,
  label = "Select platform",
  sx,
}) => {
  const selected = normalizePlatformValues(value);

  const handleChange = (e) => {
    const next = e.target.value;
    onChange(normalizePlatformValues(Array.isArray(next) ? next : []));
  };

  return (
    <Box sx={{ minWidth: 0 }}>
      <FormInput
        id="notification-platform"
        type="select"
        multiple
        size="small"
        fullWidth
        label={label}
        value={selected}
        onChange={handleChange}
        options={PLATFORM_OPTIONS}
        MenuProps={inAppNotificationDialogMenuProps}
        required={!readOnly}
        disabled={readOnly}
        renderValue={(items) => {
          const values = normalizePlatformValues(items);
          if (!values.length) return "";
          return values.map(labelFor).join(", ");
        }}
        renderOption={(option) => (
          <MenuItem key={option.value} value={option.value} dense>
            <Checkbox checked={selected.includes(option.value)} size="small" sx={{ p: 0.5, mr: 1 }} />
            <ListItemText primary={option.label} />
          </MenuItem>
        )}
        sx={sx ?? (compact ? compactInputSx : undefined)}
      />
      {error ? (
        <Box
          component="span"
          sx={{ display: "block", color: "error.main", fontSize: "0.75rem", mt: 0.5 }}
        >
          {error}
        </Box>
      ) : null}
    </Box>
  );
};

export default PlatformSelector;
